// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"6d9bb113","534":"a3d9ab69","840":"44ffb7fc","870":"e82a7876"}[chunkId] + ".chunk.js";
};